/* Get Browser */
document.addEventListener("DOMContentLoaded", function () {
  let browser = "unknown";

  if (
    navigator.userAgent.indexOf("Chrome") !== -1 &&
    navigator.userAgent.indexOf("Edg") === -1
  ) {
    browser = "browser--chrome";
  } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
    browser = "browser--firefox";
  } else if (
    navigator.userAgent.indexOf("Safari") !== -1 &&
    navigator.userAgent.indexOf("Chrome") === -1
  ) {
    browser = "browser--safari";
  } else if (navigator.userAgent.indexOf("Edg") !== -1) {
    browser = "browser--edge";
  } else if (
    navigator.userAgent.indexOf("Opera") !== -1 ||
    navigator.userAgent.indexOf("OPR") !== -1
  ) {
    browser = "browser--opera";
  } else if (
    navigator.userAgent.indexOf("MSIE") !== -1 ||
    navigator.userAgent.indexOf("Trident") !== -1
  ) {
    browser = "browser--ie";
  }

  document.body.classList.add(browser);
});

/* Hide empty blocks */
document.addEventListener("DOMContentLoaded", function () {
  const selectors = [".shopify-block", ".social-icons__wrapper"];

  selectors.forEach((selector) => {
    const elements = document.querySelectorAll(selector);

    elements.forEach((el) => {
      if (!el.innerHTML.trim()) {
        el.style.display = "none";
      }
    });
  });
});

/* Get footer height */
/* Get header and footer heights */
document.addEventListener("DOMContentLoaded", function () {
  var footer = document.querySelector("footer");
  var header = document.querySelector("#header-group");

  var footerHeight = footer.offsetHeight;
  var headerHeight = header.offsetHeight;

  document.documentElement.style.setProperty(
    "--footer-height",
    footerHeight + "px",
  );

  document.documentElement.style.setProperty(
    "--header-height",
    headerHeight + "px",
  );
});

/* DIALOG */
const trigger = document.getElementById("conditions");
const dialog = document.getElementById("conditions-dialog");

trigger.addEventListener("click", (e) => {
  e.preventDefault();
  dialog.showModal();
});

dialog
  .querySelector(".dialog-close")
  .addEventListener("click", () => dialog.close());

// Optional: close when clicking the backdrop
dialog.addEventListener("click", (e) => {
  if (e.target === dialog) dialog.close();
});